import React from 'react';
import { contact, disclaimer, hero } from '../content/siteContent';

function SiteFooter() {
  return (
    <footer className="main-footer">
      <div className="footer-bottom centred">
        <div className="auto-container">
          <div className="copyright">
            <p><strong>{hero.brand} – {hero.tagline}</strong></p>
            <p>{hero.partner}</p>
            <p>
              <a href={contact.phoneTel}>{contact.phone}</a>
              {' · '}
              <a href={contact.emailMailto}>{contact.email}</a>
              {' · '}
              <a href={contact.emailSecondaryMailto}>{contact.emailSecondary}</a>
              {' · '}
              {contact.location}
            </p>
            <p style={{ marginTop: '12px', fontSize: '13px', lineHeight: '1.6' }}>{disclaimer}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
